<template>
  <app-page class="special-cars">
    <car-query :query="query"/>

    <section class="mt-8 mb-2">
      <h1 class="title mt-0 mb-2">車両一覧</h1>

      <div
        v-if="cars.length > 0"
        class="d-flex"
      >
        <span>ご利用の車両を選択して下さい。</span>
        <v-spacer/>
        <span>{{cars.length}} 件</span>
      </div>
      <div v-else>
        <span>該当する車両は見つかりません。</span>
      </div>

      <v-row>
        <v-col
          cols="12" md="6"
          v-for="car in cars"
          :key="car.id"
        >
          <car-item :car="car" />
        </v-col>
      </v-row>
    </section>
  </app-page>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopBase from '@/app/special/mixins/ShopBase'
import CarQuery from './CarQuery'
import CarItem from './CarItem'

import * as C from '@/app/special/consts'

export default {
  name: 'specialCars',
  mixins: [
    ShopBase('車から探す')
  ],
  components: {
    CarQuery,
    CarItem
  },
  data () {
    return {
      query: {
        cartype: 'all',
        seat: 'all'
      }
    }
  },
  computed: {
    ...mapGetters('shop', [
      'm_cars'
    ]),

    cars () {
      let seat = C.seats.find(item => item.code === this.query.seat)
      if (!seat) {
        seat = C.seats[0]
      }

      return this.m_cars.filter(item => {
        if (this.query.cartype !== 'all' && this.query.cartype !== item.type) {
          return false
        }

        if (seat.first > item.seat || item.seat > seat.last) {
          return false
        }

        return true
      })
    }
  }
}
</script>
